import React, { useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faSpinner } from "@fortawesome/free-solid-svg-icons";
import {
  faTwitter,
  faFacebook,
  faLinkedin,
  faGithub,
} from "@fortawesome/free-brands-svg-icons";
import emailjs from "emailjs-com";
import classes from "./Contact.module.css";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { Button } from "react-bootstrap";
const Contact = () => {
  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wkz1fvf",
        "template_hf3r6um",
        e.target,
        "user_OD9V3PiHxM36AyoGTVMBe"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  }

  return (
    <div className={classes.conContainer}>
      <div className={classes.viewPage}>
        <div className={classes.getInTouch}>
          <div className={classes.workTogether}>
            <p className={classes.firstP}>Let's Work Together</p>
            <p className={classes.secondP}>
              Have a project you'd like to discuss?
            </p>
          </div>
          <div className={classes.formWrapper}>
            <form onSubmit={sendEmail}>
              <p>Name</p>
              <input type="text" name="name" rules="required" />
              <p>E-mail</p>
              <input type="email" name="email" rules="required|email|max:255" />
              <p>Subject</p>
              <input type="text" name="subject" />
              <p>Message</p>
              <textarea name="message" rules="required"></textarea>
              <br />
              <button
                style={{ textDecoration: "none" }}
                class={classes.frameBtn}
                type="submit"
              >
                <span
                  class={`${classes.frameBtnOutline} ${classes.frameBtnOutlineTall}`}
                >
                  <span
                    class={`${classes.frameBtnLine} ${classes.frameBtnLineTall}`}
                  ></span>
                  <span
                    class={`${classes.frameBtnLine} ${classes.frameBtnLineFlat}`}
                  ></span>
                </span>
                <span
                  class={`${classes.frameBtnOutline} ${classes.frameBtnOutlineFlat}`}
                >
                  <span
                    class={`${classes.frameBtnLine} ${classes.frameBtnLineTall}`}
                  ></span>
                  <span
                    class={`${classes.frameBtnLine} ${classes.frameBtnLineFlat}`}
                  ></span>
                </span>
                <span class={classes.frameBtnSolid}></span>
                <span class={classes.frameBtnText}>Send</span>
              </button>
            </form>
          </div>
        </div>
        <div className={classes.getSocial}>
          <div className={classes.faCode}>
            <a
              className={classes.mail}
              href="mailTo:shahriarfahim19@gmail.com"
              style={{ color: "white" }}
            >
              {" "}
              <FontAwesomeIcon icon={faEnvelope} />{" "}
            </a>
            <a href="mailTo:shahriarfahim19@gmail.com" className={classes.text}>
              shahriarfahim19@gmail.com
            </a>
          </div>

          <div className={classes.faCode1}>
            <a
              href="https://www.instagram.com/shahriarfahim04/"
              target="_blank"
              style={{ color: "white" }}
            >
              {" "}
              <FontAwesomeIcon icon={faInstagram} />{" "}
            </a>
            <a
              href="https://www.instagram.com/shahriarfahim04/"
              target="_blank"
              className={classes.text}
            >
              On Instagram
            </a>
          </div>
          <div className={classes.faCode1}>
            <a
              href="https://www.linkedin.com/in/shahriarfahim04/"
              style={{ color: "white" }}
              target="_blank"
            >
              {" "}
              <FontAwesomeIcon icon={faLinkedin} />{" "}
            </a>
            <a
              href="https://www.linkedin.com/in/shahriarfahim04/"
              target="_blank"
              className={classes.text}
            >
              On LinkedIn
            </a>
          </div>
          <div className={classes.faCode1}>
            <a
              href="https://github.com/Fahim04blue"
              target="_blank"
              style={{ color: "white" }}
            >
              {" "}
              <FontAwesomeIcon icon={faGithub} />{" "}
            </a>
            <a
              href="https://github.com/Fahim04blue"
              target="_blank"
              className={classes.text}
            >
              On Github
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
